// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './vuex/store'

//引入公共配置文件
import rwConfig from './assets/js/rwConfig.js'
Vue.prototype.$rwConfig = rwConfig;
//引入父子方法桥
import bus from './assets/js/eventBus.js'
Vue.prototype.$bus = bus;
//引入公共方法文件
var rwJsObj = {};
import rwJS from '@/assets/js/rwJS.js'
Vue.prototype.$rwJS = rwJsObj = new rwJS();
// 引入复制插件
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);
//引入jsonp
import VueJsonp from 'vue-jsonp'
Vue.use(VueJsonp);
var apiDomain = (document.domain).substring(((document.domain).indexOf('.')) + 1, (document.domain).length);
Vue.prototype.$apiDomain = apiDomain;
import dialogDrag from './assets/js/dialogDrag.js'

import 'remixicon/fonts/remixicon.css'


router.beforeEach((to,form,next)=>{
	store.dispatch('getLangPackByBackstage').then(langPackData=>{
		Vue.prototype.$rwJS.lang = langPackData
		next()
	  });
})


/* eslint-disable no-new */
var vueObj = {
	el: '#app',
	router,
	store,
	components: { App },
	template: '<App/>'
};

new Vue(vueObj)



// WEBPACK FOOTER //
// ./src/main.js